import React from 'react';
import Block from './Block';
import PillTag from './PillTag';
import BarChart from './BarChart';

/**
 * Renders a `shap_summary` block from ShapResult. Backend supplies
 * { feature_names, mean_abs_shap (per-feature), relationships: [text, ...] }.
 */
const ShapSummary = ({ blockData = {} }) => {
  const featureBars = (blockData.top_features || []).slice(0, 15).map(f => ({
    label: f.name,
    value: Number(f.mean_abs_shap || 0),
  }));
  const relationships = blockData.relationships || [];

  return (
    <Block
      icon="sparkles"
      title="What drives the prediction"
      badge={<PillTag tone="accent">{featureBars.length} features</PillTag>}
    >
      {featureBars.length > 0 && (
        <BarChart
          title="Average influence per feature"
          data={featureBars}
          valueFormat={(v) => v.toFixed(3)}
        />
      )}
      {relationships.length > 0 && (
        <ul style={{ margin: '14px 0 0', paddingLeft: 18, color: 'var(--fg)', fontSize: 'var(--font-size-sm)', lineHeight: 1.6 }}>
          {relationships.slice(0, 6).map((r, i) => (
            <li key={i} style={{ marginBottom: 4 }}>{r}</li>
          ))}
        </ul>
      )}
    </Block>
  );
};

export default ShapSummary;
